import React from 'react'
import img1 from '../components/images/retail_weighing/retail scales.png'
function Retail_scales() {
  return (
    <div>
        <section>
            <div className="w-full h-full relative mt-5 font-poppins">
                <img
                    src={img1}
                    alt="Banner"
                    className="w-full h-full object-cover"
                />
            </div>             
        </section>
    </div>
  )
}

export default Retail_scales
